alert(2)



//////////////////
// WEBPACK FOOTER
// ./src/resources/_test/main.js
// module id = 0
// module chunks = 0